import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { StateDistric } from "../../../api/EnquiryService";
import { Createstaff, fetchstaff } from "../../../api/FacultyService";
import { GetStaffId } from "../../../api/FacultyService";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { ToastMain ,SweetAlertShow} from "../../master/Master";

const AddStaff = () => {
  const [loading, setLoading] = React.useState(false);
  const [allStates, setAllStates] = React.useState([]);
  const [allDistricts, setAllDistricts] = React.useState([]);
  const [filteredDistricts, setFilteredDistricts] = React.useState([]);
  const [selectedStateId, setSelectedStateId] = React.useState("");
  const [Result, setResult] = React.useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [Teacher, setTeachers] = React.useState("");
  const [staffId, setStaffId] = useState(null);
  const [userType, setUserType] = useState("");
  const [address, setAddress] = useState(false)
  const [additionalDetails, setAdditionalDetails] = useState(false)
  const [qualification, setQualification] = useState(false)

  const qualificationToggle = () => {
    setQualification((prev) => !prev)
  }

  const handleAddtionalToggle = () => {
    setAdditionalDetails((prev) => !prev)
  }
  const handleToggle = () => {
    setAddress((prev) => !prev);
  };

  const getState = async () => {
    setLoading(true);
    try {
      const response = await StateDistric();
      if (response.data.status) {
        console.log("Fetched:", response.data.data.states);
        setAllStates(response.data.data.states);
        setAllDistricts(response.data.data.districts);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getState();
    staffFatchid();
  }, []);

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedStateId(stateId);

    // Filter districts by state_id
    const filtered = allDistricts.filter(
      (district) => district.state_id == stateId
    );
    setFilteredDistricts(filtered);
  };

  const handlestaffCreate = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData.entries());

      const response = await Createstaff(data);
      console.log(response);
      if (response.data) {
        setResult(" " + response.data.message);
        console.log("Created Subject:", response);
        // handleClose();
        // ✅ SweetAlert for success
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || 'someting went wrong',
        }).then(() => {
          navigate("/Teachers"); // ✅ Navigate after alert OK
        });
      } else {
        setResult(" Subject creation failed.");
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: err?.response?.data?.message || 'someting went wrong'
      // })

      SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)

    }
  };
  const staffFatchid = async () => {
    try {
      const response = await GetStaffId(); // ✅ Call your API

      if (response.data) {
        const data = response.data; // ✅ Extract data from response

        console.log("StaffId API response", data);

        setStaffId(data.staff_id); // ✅ Set staff_id
      } else {
        Swal.fire("Error", "Failed to fetch teacher ID", "error");
      }
    } catch (error) {

    }
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="container-fluid mt-4">
            <div className="card p-4 shadow-sm rounded-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="text-primary fw-bold">Add Faculty</h3>
                <Link
                  to={"/teachers"}
                  className="btn btn-outline-primary btn-sm"
                >
                  <i className="bi bi-arrow-left-circle me-1"></i>
                  back
                </Link>
              </div>
              <hr />

              <form onSubmit={handlestaffCreate}>
                {/* Basic Info */}
                <div className="p-3 rounded">
                  <h5 className="text-primary fw-bold">Basic Details </h5>
                  <div className="row g-3  ">
                    <div className="col-md-6 form-floating form-floating-outline  mb-1">
                      <input
                        type="text"
                        name="staff_id"
                        className="form-control"
                        placeholder="Staff ID"
                        value={staffId}
                        onChange={(e) => setStaffId(e.target.value)}

                        required
                      />
                      <label>
                        Staff ID <span className="text-danger">*</span>
                      </label>
                    </div>

                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="text"
                        name="staff_name"
                        className="form-control input-uppercase"
                        placeholder="Full Name"
                        required
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      <label>
                        Full Name <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="text"
                        name="mobile"
                        className="form-control"
                        maxLength={10}
                        placeholder="Mobile"
                        required
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/g, ""))
                        }
                      />
                      <label>
                        Mobile <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="text"
                        name="secondary_mobile"
                        className="form-control"
                        maxLength={10}
                        placeholder="Alternate Number"
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/g, ""))
                        }
                      />
                      <label>Alternate Number</label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="text"
                        className="form-control input-uppercase"
                        name="father_name"
                        placeholder="Father's Name"

                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      <label>
                        Father's Name
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                      />
                      <label>Email</label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <select name="gender" className="form-select" required>
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                      <label>
                        Select Gender<span className="text-danger">*</span>
                      </label>
                    </div>

                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input type="date" name="dob" className="form-control" />
                      <label>Date Of Birth</label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="text"
                        name="aadhar"
                        className="form-control"
                        maxLength={12}
                        placeholder="Aadhaar Number"

                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/g, ""))
                        }
                      />
                      <label>
                        Aadhaar Number
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="text"
                        name="referred_by"
                        className="form-control"
                        placeholder="Referred By"
                        onChange={(e) => {
                          const value = e.target.value;
                          e.target.value = value
                            .split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ");
                        }}
                      />
                      <label>
                        Referred By
                      </label>
                    </div>
                    <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                      <input
                        type="Date"
                        name="join_date"
                        className="form-control"
                        placeholder="Join Dete"

                      />
                      <label>
                        Joining Details <span className="text-danger">*</span>
                      </label>
                    </div>
                  </div>
                </div>

                <hr />
                <div className="form-check form-switch mb-3 ms-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="addressSwitch"
                    checked={qualification}
                    onChange={qualificationToggle}
                  />
                  <label className="form-check-label" htmlFor="addressSwitch">
                    Add Qualification Details
                  </label>
                </div>
                {qualification && (
                  <>
                    {/* Address Info */}
                    <div className="p-3 rounded">
                      <h5 className="text-primary fw-bold">
                        {" "}
                        Qualification Details
                      </h5>
                      <div className="row g-3  ">
                        <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <input
                            type="text"
                            name="education"
                            className="form-control"
                            placeholder="Qualification"
                            onChange={(e) => {
                              const value = e.target.value;
                              e.target.value = value
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ");
                            }}
                          />
                          <label>Qualification </label>
                        </div>
                        <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <input
                            type="text"
                            name="school_name"
                            className="form-control input-uppercase"
                            placeholder="Last School"
                            onChange={(e) => {
                              const value = e.target.value;
                              e.target.value = value
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ");
                            }}
                          />
                          <label>Last School</label>
                        </div>
                      </div>
                    </div>

                  </>
                )}



                <hr />
                <div className="form-check form-switch mb-3 ms-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="addressSwitch"
                    checked={address}
                    onChange={handleToggle}
                  />
                  <label className="form-check-label" htmlFor="addressSwitch">
                    Add Address Details <span className="text-danger">*</span>
                  </label>
                </div>




                {address && (
                  <>
                    {/* Address Info */}
                    <div className="p-3 rounded">
                      <h5 className="text-primary fw-bold">Address</h5>
                      <div className="row g-3  ">
                        <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <input
                            type="text"
                            name="village"
                            className="form-control input-uppercase"
                            placeholder="Village"

                            onChange={(e) => {
                              const value = e.target.value;
                              e.target.value = value
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ");
                            }}
                          />
                          <label>
                            Village
                          </label>
                        </div>
                        
                        <div className="col-md-6 mb-5 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <select
                            className="form-select"
                            name="state"
                            value={selectedStateId}
                            onChange={handleStateChange}
                            required
                          >
                            <option value="">Select State</option>
                            {allStates?.map((state) => (
                              <option key={state.id} value={state.id}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                          <label>State
                            <span className="text-danger">*</span></label>

                        </div>
                        <div className="col-md-6 mb-5 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <select className="form-select" name="district" required>
                            <option value="" name="district">
                              Select District
                            </option>
                            {filteredDistricts?.map((district) => (
                              <option key={district.id} value={district.name}>
                                {district.name}
                              </option>
                            ))}
                          </select>
                          <label>
                            District
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <input
                            type="text"
                            name="pincode"
                            className="form-control"
                            placeholder="Pincode"
                            maxLength={6}
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(/\D/g, ""))
                            }
                          />
                          <label>Pincode</label>
                        </div>
                      </div>
                    </div>

                  </>
                )}
                <hr />

                <div className="form-check form-switch mb-3 ms-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="addressSwitch"
                    checked={additionalDetails}
                    onChange={handleAddtionalToggle}
                  />
                  <label className="form-check-label" htmlFor="addressSwitch">
                    Add Payrol Details <span className="text-danger">*</span>
                  </label>
                </div>

                {additionalDetails && (
                  <>
                    {/* Additional Details */}
                    <div className="p-3 rounded">
                      <h5 className="text-primary fw-bold">Additional Details</h5>
                      <div className="row g-3  ">
                        <div className="col-md-6 form-floating form-floating-outline mb-1 fv-plugins-icon-container">
                          <select
                            name="user_type"
                            className="form-select"
                            required
                            value={userType}
                            onChange={(e) => setUserType(e.target.value)}
                          >
                            <option value="">Select Type</option>
                            <option value="Teacher">Teacher</option>
                            <option value="Counselor">Counselor</option>
                            <option value="Accountant">Accountant</option>
                            <option value="Staff">Staff</option>
                          </select>
                          <label>
                            Select Type<span className="text-danger">*</span>
                          </label>
                        </div>

                        {/* {userType === "Teacher" && (
                      <div className="col-md-6 form-floating form-floating-outline mb-1 fv-plugins-icon-container">
                        <select
                          name="user_type[]"
                          className="form-select"
                          multiple
                          style={{ height: "100px" }}
                          required
                        >
                          <option value="Hindi">Hindi</option>
                          <option value="English">English</option>
                          <option value="Maths">Maths</option>
                          <option value="Science">Science</option>
                          <option value="SST">Social Studies</option>
                        </select>
                        <label>
                          Select Subject(s){" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                    )} */}

                        <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <input
                            type="Number"
                            name="salary"
                            className="form-control"
                            placeholder="Salary (Per Month)*"
                            required
                          />
                          <label>Salary (Per Month)<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-6 form-floating form-floating-outline  mb-1 fv-plugins-icon-container">
                          <input
                            type="text"
                            name="remark"
                            className="form-control input-uppercase"
                            placeholder="Remark"
                            onChange={(e) => {
                              const value = e.target.value;
                              e.target.value = value
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ");
                            }}
                          />
                          <label>Remark</label>
                        </div>
                      </div>
                    </div>

                  </>
                )}
                <hr />

                {/* Buttons */}
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate("/Teacher")} // 👈 Replace with your target route
                  >
                    Cancel
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </div>
  );
};

export default AddStaff;
